import React, { useState } from "react";
import { Search, X } from "lucide-react";

export default function Filter({
  filter,
  search,
  nse,
  mcx,
  mcx_options,
  options,
  nse_cash,
  comex,
  crypto,
  forex,
  us_stock,
  sgx,
  index,
  dgcx,
  ncdex,
  close,
}) {
  const [query, setQuery] = useState("");
  const [activeFilter, setActiveFilter] = useState(null);

  // ✅ Dynamically include only active markets
  const filters = [
    nse ? { id: 0, name: "NSE Future" } : null,
    mcx ? { id: 1, name: "MCX Future" } : null,
    mcx_options ? { id: 2, name: "MCX Options" } : null,
    options ? { id: 3, name: "NSE Options" } : null,
    nse_cash ? { id: 4, name: "NSE Equity" } : null,
    comex ? { id: 5, name: "Comex" } : null,
    crypto ? { id: 6, name: "Crypto" } : null,
    forex ? { id: 7, name: "Forex" } : null,
    us_stock ? { id: 8, name: "Us Stock" } : null,
    sgx ? { id: 9, name: "Sgx" } : null,
    index ? { id: 10, name: "Others" } : null,
    dgcx ? { id: 11, name: "Dgcx" } : null,
    ncdex ? { id: 12, name: "Ncdex" } : null,
  ].filter(Boolean); // remove null entries

  const handleFilterClick = (id) => {
    setActiveFilter(id);
    filter(id);
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setQuery(value);
    search(value);
  };

  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-2 px-3 py-2 bg-[var(--background)] shadow-sm ">
      {/* 🔍 Search Box */}
      <div className="relative w-full sm:w-1/4">
        <Search
          size={14}
          className="absolute left-3 top-2 text-[var(--text)]"
        />
        <input
          type="text"
          placeholder="Search..."
          value={query}
          onChange={handleSearch}
          className="w-full pl-8 pr-7 py-1.5 text-xs rounded-lg border border-[var(--hover)] bg-[var(--background)] text-[var(--text)] focus:outline-none focus:ring-1 focus:ring-[var(--hover)] transition-all"
        />
        {query && (
          <X
            size={12}
            className="absolute right-3 top-2.5 cursor-pointer text-[var(--text)]"
            onClick={() => {
              setQuery("");
              search("");
            }}
          />
        )}
      </div>

      {/* 🧭 Market Filters */}
      <div className="flex flex-wrap justify-center sm:justify-end gap-1.5">
        <button
          onClick={() => {
            setActiveFilter(null);
            filter(-1);
          }}
          className={`px-2.5 py-1 rounded-lg text-[10px] font-medium transition-all ${
            activeFilter === null
              ? "bg-[var(--primary)] text-white"
              : "border border-[var(--hover)] text-[var(--text)]"
          }`}
        >
          All
        </button>

        {filters.map((f) => (
          <button
            key={f.id}
            onClick={() => handleFilterClick(f.id)}
            className={`px-2.5 py-1 rounded-lg text-[10px] font-medium transition-all ${
              activeFilter === f.id
                ? "bg-[var(--primary)] text-white"
                : "border-2 border-[var(--hover)] text-[var(--text)]"
            }`}
          >
            {f.name}
          </button>
        ))}

        {close && (
          <button
            onClick={close}
            className="px-2.5 py-1 rounded-lg border border-[var(--hover)] text-[var(--text)] hover:bg-red-500 hover:text-white transition-all text-[10px] font-medium"
          >
            Close
          </button>
        )}
      </div>
    </div>
  );
}
